import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Phone, MessageSquare } from 'lucide-react';
const faqs = [{
  q: "How do I know you'll actually show up?",
  a: "Jose's is a local Monterey business with a real reputation on the line. We show up — on time, ready to work."
}, {
  q: 'Do you handle really big jobs?',
  a: 'Yes. From a single item to a full hoarder cleanout or construction site — we scale to the job.'
}, {
  q: "What if I don't know how much stuff I have?",
  a: "Just call and describe it, or text a photo. We'll give you a straightforward estimate. No surprises."
}, {
  q: 'Do you take everything?',
  a: 'Furniture, appliances, concrete, dirt, green waste, construction debris, specialty items — the answer is almost always yes.'
}, {
  q: 'How fast can you come out?',
  a: "Often same-day or next-day. Call (831) 240-7401 and we'll get you scheduled fast."
}, {
  q: 'Is this more expensive than renting a dumpster?',
  a: "When you factor in rental fees, your time, your labor, dump fees, and multiple trips — Jose's is often the smarter investment."
}, {
  q: 'Do you serve my area?',
  a: "If you're within 50 miles of Monterey, CA — most likely yes. Call and confirm in 30 seconds."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-20 lg:py-28 bg-[#F9F9F9]" data-id="element-108" data-mp="11w7g3cauw60x">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109" data-mp="16np655bccm74">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-110" data-mp="16pa311l4oh85">
          {/* Rail */}
          <div className="lg:col-span-4" data-id="element-111" data-mp="s0maz5ahqpmy">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            ease: [0.23, 1, 0.32, 1]
          }} className="lg:sticky lg:top-32" data-id="element-112" data-mp="wy5pm6b3p4ff">
              <span className="text-[11px] tracking-[0.25em] font-bold uppercase text-[#C8102E] block mb-4" data-id="element-113" data-mp="2pmn39s4xdny1">
                Straight Answers
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-[1.05] mb-6" data-id="element-114" data-mp="2kuc5autqwc84">
                FREQUENTLY
                <br data-id="element-115" data-mp="2fuhcumubneky" />
                ASKED
                <br data-id="element-116" data-mp="2ayijeku4z6do" />
                <span className="text-[#C8102E]" data-id="element-117" data-mp="2az24gaf32avx">QUESTIONS</span>
              </h2>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-118" data-mp="38kg66ufjtxvf">
                Still not sure? Call or text and we'll tell you straight — no
                pressure, no runaround.
              </p>

              <div className="flex flex-wrap gap-3" data-id="element-119" data-mp="2yma7elp1h7us">
                <a href="tel:8312407401" className="inline-flex items-center gap-2 bg-[#C8102E] text-white px-5 py-3 rounded-xl font-bold text-sm hover:bg-[#8B0A20] transition-colors" data-id="element-120" data-mp="2ulq9vh0k0284">
                  <Phone size={16} data-id="element-121" data-mp="1j5i3f4i046r6" />
                  Call
                </a>
                <a href="sms:8312407401" className="inline-flex items-center gap-2 bg-white border border-gray-200 text-[#1A1A1A] px-5 py-3 rounded-xl font-bold text-sm hover:border-[#C8102E] hover:text-[#C8102E] transition-colors" data-id="element-122" data-mp="3uug8jz1dv1p6">
                  <MessageSquare size={16} data-id="element-123" data-mp="cfxaxtmzc9sx" />
                  Text
                </a>
              </div>
            </motion.div>
          </div>

          {/* Accordion */}
          <div className="lg:col-span-8" data-id="element-124" data-mp="hh4h5o9h50xh">
            <div className="bg-white rounded-2xl border border-gray-200 divide-y divide-gray-100 overflow-hidden" data-id="element-125" data-mp="mdld34mx0jl4">
              {faqs.map((faq, idx) => {
              const isOpen = openIndex === idx;
              return <div key={faq.q} data-id="element-126" data-mp="ve9ixc25ndmx" data-mpi={idx}>
                    <h3 data-id="element-127" data-mp="2s72xzpmerplc">
                      <button onClick={() => setOpenIndex(isOpen ? null : idx)} aria-expanded={isOpen} className="w-full px-6 sm:px-8 py-6 text-left flex items-start justify-between gap-5 group" data-id="element-128" data-mp="2s7l1967hn42r">
                        <span className={`font-bold text-base sm:text-lg normal-case transition-colors ${isOpen ? 'text-[#C8102E]' : 'text-[#1A1A1A] group-hover:text-[#C8102E]'}`} style={{
                      fontFamily: 'Inter, sans-serif'
                    }} data-id="element-129" data-mp="1wxeicyxy33za">
                          {faq.q}
                        </span>
                        <span className={`flex-shrink-0 w-8 h-8 rounded-full border flex items-center justify-center transition-colors duration-200 ${isOpen ? 'bg-[#C8102E] border-[#C8102E] text-white' : 'border-gray-300 text-gray-500 group-hover:border-[#C8102E] group-hover:text-[#C8102E]'}`} data-id="element-130" data-mp="1svb6i97d5xdh">
                          <Plus size={16} className={`transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} data-id="element-131" data-mp="371o89q2e8dyr" />
                        </span>
                      </button>
                    </h3>

                    <AnimatePresence initial={false} data-id="element-132" data-mp="3pu0e4ms99xdn">
                      {isOpen && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.23, 1, 0.32, 1]
                  }} className="overflow-hidden" data-id="element-133" data-mp="3uslcshrv08zz">
                          <p className="px-6 sm:px-8 pb-6 -mt-1 text-gray-600 leading-relaxed max-w-2xl" data-id="element-134" data-mp="29de8lhq2y2at">
                            {faq.a}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}